﻿
/*---[ ESLint ]---*/
/*
    global _msg_notsaved: true,
           nodeconfiguration,
*/
window.nodeconfiguration = function () {

    var LABEL_YES = "";
    var LABEL_NO = "";
    var LABEL_DELETE = "";
    var LABEL_DELETE_APP = "";

    var _isApplicationNode = false;

    var oldDomainName = "";

    return {

        TabStripInitialize: function (isApplicationNode) {
            _isApplicationNode = isApplicationNode;
        },


        TAB_SSO_initialize: function (labelYes, labelNo, labelDelete, labelDeleteApp) {

            // Create new record ...
            $(".k-grid-add").click(function (e) {

                // Prevent default behaviour 
                e.preventDefault();

                main.setHideDiv("DivAddSubDomain", true);
                main.setHideDiv("DivUpdateSubDomain", false);
            });

            LABEL_YES = labelYes;
            LABEL_NO = labelNo;
            LABEL_DELETE = labelDelete;
            LABEL_DELETE_APP = labelDeleteApp;

            oldDomainName = "";

            main.setHideDiv("DivBtnRemoveApplication", _isApplicationNode);
        },


        onTabStripContentLoad: function (e) {

            tabstrip.onContentLoad(e);

            if (!_isApplicationNode) {
                // hide tab identity providers
                e.sender.items()[3].hidden = true;
            }

            main.setHideDivBootstrap("divTabStripnodeconfiguration", true);
        },

        afterCreateApp: function () {
            _isApplicationNode = true;
            main.setHideDiv("DivBtnRemoveApplication", true);
            $("#editTabstripNodeConfigOverview").data("kendoTabStrip").items()[3].hidden = false;
        },

        afterDeleteApp: function () {
            _isApplicationNode = false;
            main.setHideDiv("DivBtnRemoveApplication", false);
            $("#editTabstripNodeConfigOverview").data("kendoTabStrip").items()[3].hidden = true;
        },

        onRemoveAppClicked: function () {

            main.openActionsDialog(' ', LABEL_DELETE_APP,
                [{ text: LABEL_YES, action: function () { nodeconfiguration.removeApp(); main.closePopup(); } },
                { text: LABEL_NO, action: function () { main.closePopup(); } }]);
        },

        removeApp: function () {

            var actionUrl = "NodeConfig/DeleteApplication";

            $.ajax({
                type: "POST",
                url: appsettings.getUrl(actionUrl),
                success: function (responseData) {

                    if (responseData != undefined && responseData != null) {

                        if (responseData.Succesfully == false) {
                            main.openActionsDialog(' ', responseData.Message,
                                [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                        } else {
                            nodeconfiguration.afterDeleteApp();
                        }
                    }
                }
            });
        },

        editSubDomain: function (e) {

            main.setHideDiv("DivUpdateSubDomain", true);
            main.setHideDiv("DivAddSubDomain", false);

            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            var tb = $("#tbUpdateSubDomain").data("kendoTextBox");
            tb.value(dataItem.DomainName);
            oldDomainName = dataItem.DomainName;
        },

        updateSubDomain: function () {

            var tb = $("#tbUpdateSubDomain").data("kendoTextBox");

            if (tb != undefined && tb != null) {

                var actionUrl = "NodeConfig/UpdateSubDomain";

                $.ajax({
                    type: "POST",
                    url: appsettings.getUrl(actionUrl),
                    data: { oldDomainName: oldDomainName, newDomainName: tb.value() },
                    success: function (responseData) {

                        if (responseData != undefined && responseData != null) {

                            if (responseData.Succesfully == false) {
                                main.openActionsDialog(' ', responseData.Message,
                                    [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                            } else {
                                main.setHideDiv("DivUpdateSubDomain", false);
                                $("#SubDomainGrid").data("kendoGrid").dataSource.read();
                            }
                        }
                    }
                });
            }
        },

        cancelUpdateSubDomain: function () {
            $("#tbUpdateSubDomain").data("kendoTextBox").value("");
            main.setHideDiv("DivUpdateSubDomain", false);
        },

        deleteSubDomain: function (e) {

            var event = e;
            var data = this;

            var dataItem = data.dataItem($(event.currentTarget).closest("tr"));

            main.openActionsDialog(' ', LABEL_DELETE,
                [{ text: LABEL_YES, action: function () { nodeconfiguration.removeSubDomain(dataItem.DomainName); main.closePopup(); } },
                { text: LABEL_NO, action: function () { main.closePopup(); } }]);
        },

        removeSubDomain: function (domainName) {

            var actionUrl = "NodeConfig/DeleteSubDomain";

            $.ajax({
                type: "POST",
                url: appsettings.getUrl(actionUrl),
                data: { domainName: domainName },
                success: function (responseData) {

                    if (responseData != undefined && responseData != null) {

                        if (responseData.Succesfully == false) {
                            main.openActionsDialog(' ', responseData.Message,
                                [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                        }
                    }

                    $("#SubDomainGrid").data("kendoGrid").dataSource.read();
                }
            });

        },

        addNewSubDomain: function () {

            var tb = $("#tbNewSubDomain").data("kendoTextBox");

            if (tb != undefined && tb != null) {

                var actionUrl = "NodeConfig/AddSubDomain";

                $.ajax({
                    type: "POST",
                    url: appsettings.getUrl(actionUrl),
                    data: { newDomainName: tb.value() },
                    success: function (responseData) {

                        if (responseData != undefined && responseData != null) {

                            if (responseData.Succesfully == false) {
                                main.openActionsDialog(' ', responseData.Message,
                                    [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                            } else {
                                main.setHideDiv("DivAddSubDomain", false);
                                $("#SubDomainGrid").data("kendoGrid").dataSource.read();
                            }
                        }
                    }
                });
            }
        },

        cancelNewSubDomain: function () {
            $("#tbNewSubDomain").data("kendoTextBox").value("");
            $("#lblError").text("");
            main.setHideDiv("DivAddSubDomain", false);
        },


        TAB_IP_initialize: function (labelYes, labelNo, labelDelete) {

            // Create new record ...
            $(".k-grid-add").click(function (e) {

                // Prevent default behaviour 
                e.preventDefault();

                // Load create form into the current module div
                navigation.navigateToSpecificUrl("NodeConfig/AddIdentityProvider");
            });

            LABEL_YES = labelYes;
            LABEL_NO = labelNo;
            LABEL_DELETE = labelDelete;
        },

        onSelectCertificate: function (e) {
            $.each(e.files, function (index, value) {
                nodeconfiguration.readMultipleFiles_KendoUploadWidget(value, "#Certificate");
            });
        },

        onSelectLocalCertificate: function (e) {
            $.each(e.files, function (index, value) {
                nodeconfiguration.readMultipleFiles_KendoUploadWidget(value, "#LocalCertificate");
            });
        },

        readMultipleFiles_KendoUploadWidget: function (file, control) {
            var reader = new FileReader();

            reader.onload = function (e) {
                //capture value in hidden field for 'future' post form moment.
                $(control).val(e.target.result);
            }

            reader.readAsDataURL(file.rawFile);
        },

        showIdPro: function (e) {
            // Set mode 
            viewmode.setViewMode(ModuleActionViewEnum.Show);

            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("NodeConfig/EditIdentityProvider?identityProviderId=" + dataItem.IdentityProviderID + "&breadcrumbLabel=" + dataItem.Label);
        },

        editIdPro: function (e) {

            // Set mode 
            viewmode.setViewMode(ModuleActionViewEnum.Edit);

            var dataItem = this.dataItem($(e.currentTarget).closest("tr"));

            // Load create form into the current module div
            navigation.navigateToSpecificUrl("NodeConfig/EditIdentityProvider?identityProviderId=" + dataItem.IdentityProviderID + "&breadcrumbLabel=" + dataItem.Label);
        },

        deleteIdPro: function (e) {
            var event = e;
            var data = this;

            var dataItem = data.dataItem($(event.currentTarget).closest("tr"));

            main.openActionsDialog(' ', LABEL_DELETE,
                [{ text: LABEL_YES, action: function () { nodeconfiguration.removeIdPro(dataItem.IdentityProviderID); main.closePopup(); } },
                { text: LABEL_NO, action: function () { main.closePopup(); } }]);
        },

        removeIdPro: function (id) {

            var actionUrl = "NodeConfig/DeleteIdentityProvider";

            $.ajax({
                type: "POST",
                url: appsettings.getUrl(actionUrl),
                data: { identityProviderId: id },
                success: function (responseData) {

                    if (responseData != undefined && responseData != null) {

                        if (responseData.Succesfully == false) {
                            main.openActionsDialog(' ', responseData.Message,
                                [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                        }
                    }

                    $("#IdProGrid").data("kendoGrid").dataSource.read();
                }
            });
        },

        /**
        * 
        */
        TAB_Modules_initialize: function (notsaved) {
            _msg_notsaved = notsaved;
        },

        /**
        * Return label changed not saved
        */
        TAB_Modules_Get_LDataChangedNotSavedYet: function () {
            return _msg_notsaved;
        },

        /**
        * Move user to the left
        */
        TAB_Modules_leftClicked: function () {
            nodeconfiguration.TAB_Modules_enableSaveButton();
            listbox.moveItems("NodeConfiguration_Modules_CplSelected", "NodeConfiguration_Modules_CplNotSelected", "#Modules_Validation", nodeconfiguration.TAB_Modules_Get_LDataChangedNotSavedYet);
        },

        /**
        * Move user to the right
        */
        TAB_Modules_rightClicked: function () {
            nodeconfiguration.TAB_Modules_enableSaveButton();
            listbox.moveItems("NodeConfiguration_Modules_CplNotSelected", "NodeConfiguration_Modules_CplSelected", "#Modules_Validation", nodeconfiguration.TAB_Modules_Get_LDataChangedNotSavedYet);
        },

        /**
        * Enable save button
        */
        TAB_Modules_enableSaveButton: function () {
            var btnSave = document.getElementById("saveButtonModules");
            btnSave.removeAttribute("disabled");
        },

        /**
        * Save button clicked
        */
        TAB_Modules_saveButtonClicked: function (actionUrl) {

            var json = $("#NodeConfiguration_Modules_CplSelected").data("kendoListBox").dataSource.view();
            var list = json.slice();

            $.ajax({
                type: "POST",
                url: appsettings.getUrl(actionUrl),
                data: { list: kendo.stringify(list) },
                success: function (responseData) {

                    $('#Modules_Validation').text("");

                    var tabStrip = $("#editTabstripNodeConfigOverview").data("kendoTabStrip");
                    var tab = tabStrip.select();
                    tabStrip.reload(tab);

                    var color = (responseData.Succesfully ? 'green' : 'red');
                    $('#Modules_Validation').text(responseData.Message);
                    $('#Modules_Validation').attr('style', 'color:' + color);
                }
            });
        },

        /**
        * Get Occupancy for the left and right.
        * @param {number} groupId
        */
        TAB_Modules: function () {
            $("#TableModules").load(appsettings.getUrl("NodeConfig/GetModules"));
        },

        IdentityProviderTypeID_OnChange: function (e) {
            //var type = e.sender.element[0].value;
            nodeconfiguration.setHideTypeFields(this.value());
        },

        setHideTypeFields: function (selectedType) {
            main.setHideDivBootstrap("divSAML", false);
            main.setHideDivBootstrap("divOAuth", false);            

            switch (selectedType) {
                case "1":
                    main.setHideDivBootstrap("divSAML", true);
                    break;
                case "2":
                    main.setHideDivBootstrap("divOAuth", true);
                    break;
            }
        }
    }

}();